module.exports = __webpack_public_path__ + "assets/img/2601.76276ab6.png";